/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import commonFunc from '@/common/commonFunction';

export default {
	SystemNoti: function(state) {
		return state.SystemNoti;
	}
};
